import React, { Fragment } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import formatCurrency from 'format-currency';

import { formatDate } from 'bookingform';
import FreeModeError from './FreeModeError';
import CartIcon from '../../icons/CartIcon';
import TrashIcon from '../../icons/TrashIcon';

import { emptyShoppingCart, setCartUpdating } from '../../../actions/Cart';
import { removeFreeModeExtra, removeFreeModeRoom } from '../../../actions/FreeModeCart';
import { getLangValue } from '../../../utils/Generic';
import { getOccupancyLabel } from '../../../utils/Room';
import DsLabel from '../../ds/atoms/label';
import {
  LOYALTY_STATUS, setCoinsApplied, setCoinsEntered, setMaxCoinsToApply,
} from '../../../actions/Loyalty';
import {
  convertCoinsToCurrencyUsingRoundedConversionRate,
} from '../../../utils';
import { LOYALTY_COINS_DISABLED, CALL_CENTER_ROLE } from '../../../constants';
import { formatMonthDayDate } from '../../../services/dates';
import withNavigate from '../../../withNavigate'; // Importa el HOC
import { FinalRoomsAmount, getUpperLimit } from '../utils';

class FreeModeCart extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showMobileCart: false,
    };

    this.clearCart = this.clearCart.bind(this);
    this.toggleShowMobileCart = this.toggleShowMobileCart.bind(this);
    this.goToConfirmation = this.goToConfirmation.bind(this);
    this.renderCoinsDiscount = this.renderCoinsDiscount.bind(this);
    this.goToRoomSelection = this.goToRoomSelection.bind(this);
    this.formatDate = this.formatDate.bind(this);
  }

  componentDidUpdate() {
    /*if (this.props.cart.cartHotel.isEmpty) {
      this.props.setMaxCoinsToApply(0);
    } else {
      this.props.setMaxCoinsToApply(
        getMaxCoinsToApply(this.props.cart.amount[this.props.hotel.default_currency]));
    }*/
  }

  isEmptyCart() {
    return this.props.cart.cartHotel.isEmpty;
  }

  goToConfirmation() {
    if (!this.isEmptyCart()) {
      this.props.navigate('/confirmation/');
    }
  }

  toggleShowMobileCart() {
    this.setState({ showMobileCart: !this.state.showMobileCart });
  }

  clearCart() {
    this.props.emptyShoppingCart();
    this.props.setCoinsApplied(0);
    this.props.setCoinsEntered(0);
  }

  removeCartRoom(roomCartId) {
    this.props.setCartUpdating(true);
    this.props.removeFreeModeRoom(roomCartId).then(() => {
      if (this.props.cart.cartHotel.isEmpty || this.props.showLoyalty === LOYALTY_COINS_DISABLED
              || this.props.selectedStatus === LOYALTY_STATUS.DONT_WANT_MEMBER) {
        this.props.setCoinsApplied(0);
        this.props.setCoinsEntered(0);
      } else {
        this.applyMaxCoins(this.props.cart.amount[this.props.hotel.default_currency]);
      }
      this.props.setCartUpdating(false);
      this.props.navigate('/all-rooms/');
    });
  }

  goToRoomSelection() {
    this.props.navigate('/all-rooms/');
  }

  removeCartExtra(roomCartId, extraUuId) {
    this.props.setCartUpdating(true);
    this.props.removeFreeModeExtra({ roomCartId, extraUuId }).then(() => {
      this.props.setCartUpdating(false);
    });
  }

  // eslint-disable-next-line no-unused-vars
  applyMaxCoins(price) {
    this.props.setCoinsApplied(getUpperLimit(this.props));
    this.props.setCoinsEntered(getUpperLimit(this.props));
  }

  getCartItemAmount(cartItem) {
    const currencyCode = this.props.userCurrency.code;
    const amounts = cartItem.amount;
    return amounts[currencyCode];
  }

  getCartItemExtrasAmount(cartItem) {
    const currencyCode = this.props.userCurrency.code;
    let extraAmounts = 0;
    if (cartItem.extras && cartItem.extras.length > 0 && cartItem.extras) {
      cartItem.extras.forEach((item) => {
        extraAmounts += item.prices[currencyCode].amount;
      });
    }
    return extraAmounts;
  }

  getCartTotals(rooms) {
    // We add the prices and the number of paxes of each type, each on its own accumulator variable
    const accum = {
      totalPrice: 0, adults: 0, allChildren: 0, ages: [],
    };
    // In the cart, "childs" has all children types. So we can't distinguish which are
    return rooms.reduce((totals, cartItem) => {
      const cartUse = cartItem.use; // adults, childs (any type), ages
      return {
        adults: totals.adults + cartUse.adults,
        allChildren: totals.allChildren + cartUse.childs,
        ages: totals.ages.concat(cartUse.ages),
        totalPrice: totals.totalPrice + this.getCartItemAmount(cartItem) + this.getCartItemExtrasAmount(cartItem),
      };
    }, accum);
  }

  renderRoomDates(room) {
    return (
            <div className="room__dates">
        <span className="font-weight-bold">
          {formatDate(room.checkIn, this.props.lang, this.props.chain)}
          &nbsp;-&nbsp;
          {formatDate(room.checkOut, this.props.lang, this.props.chain)}
        </span>
              <span className="text-muted ml-2 text-nowrap">
          ({this.context.t(['{n} night', '{n} nights', 'n'], { n: room.nights })})
        </span>
            </div>
    );
  }

  renderRoom(cartItem, index) {
    return (
            <div className="room" key={`cart-room-${index}`}>
              <div className="room__header">
                <span>{this.context.t(`Room ${index + 1}`)}</span>
                <TrashIcon onClick={() => this.removeCartRoom(cartItem.unique_id)}/>
              </div>
              <div className="room__details">
                <b>{getLangValue(cartItem.room, this.props.lang, 'name')}</b>
                <ul className="list-unstyled text-dark-gray small">
                  <li>{this.renderRoomDates(cartItem)}</li>
                  <li>{getLangValue(cartItem.rate, this.props.lang, 'name')}</li>
                  <li>{getLangValue(cartItem.board, this.props.lang, 'name')}</li>
                  <li>{getOccupancyLabel(cartItem.use, this.context)}</li>
                  <li className="text-primary">
                    {
                      this.props.hotel.percentage_total_taxes != null
                      && this.props.hotel.percentage_total_taxes > 0 && this.props.isCallCenterUser === false
                        ? (
                          <>
                            {formatCurrency(
                              this.getCartItemAmount(cartItem)
                              - (this.getCartItemAmount(cartItem) * (this.props.hotel.percentage_total_taxes / 100)),
                              this.props.userCurrency,
                            )}
                            {' + taxes '}
                            {formatCurrency(
                              this.getCartItemAmount(cartItem)
                              * (this.props.hotel.percentage_total_taxes / 100),
                              this.props.userCurrency,
                            )}
                          </>
                        )
                        : (
                          formatCurrency(
                            this.getCartItemAmount(cartItem),
                            this.props.userCurrency,
                          )
                        )
                    }
                  </li>
                  <li>
                    {this.renderCartExtras(cartItem)}
                  </li>
                </ul>
              </div>
            </div>
    );
  }

  renderEmptyCartButton(totalRooms) {
    // The button only appears when there are at least 2 rooms
    if (totalRooms <= 1) {
      return null;
    }
    return (
            <div className="cart__clearall cursor-pointer" onClick={this.clearCart}>
              <small>{this.context.t('Remove all rooms')}</small>
              <TrashIcon/>
            </div>
    );
  }

  renderButton() {
    const extraClass = this.isEmptyCart() || this.props.cart.isUpdating ? ' sandbox__btn--disabled' : '';
    return (
            <button className={`sandbox__btn sandbox__btn--small${extraClass}`} onClick={this.goToConfirmation}>
              {this.context.t('Continue')}
            </button>
    );
  }

  renderGoToRoomsButton() {
    return (
            <button className='text-primary font-bold w-full mx-auto' onClick={this.goToRoomSelection}>
              {this.context.t('Click here to add more rooms')}
            </button>
    );
  }

  renderCartPrice(totalPrice) {
    if (this.isEmptyCart()) {
      return (
              <div className="text-primary h5 mb-2">
                <b>{this.context.t('Please select your rooms')}</b>
              </div>
      );
    }
    if (this.props.cart.isUpdating) {
      return null;
    }
    return (
            <div className="total-price">
              {this.context.t('Total price')}<br/>
              <b className="text-primary h3 mt-0 pb-2">
                {formatCurrency(totalPrice > 0 ? totalPrice : 0, this.props.userCurrency)}
              </b>
            </div>
    );
  }

  renderCartExtras(cartItem) {
    const { extras } = cartItem;
    if (!extras || extras.length === 0) {
      return (<div></div>);
    }
    return (
            <div className='extra__details'>
              <hr/>
              {extras.map((extra) => (
                      <ul key={extra.code}>
                        <li>{this.context.t('Enhance Your Stay')}</li>
                        <li><b>{this.context.t('Experience')}</b> <span>{extra.code}</span></li>
                        <li className='text-right'>
                          <b>{extra.quantity} {this.unityLabel(extra)} - {this.formatDate(extra.days)}</b>
                        </li>
                        <li className='text-primary text-right'>
                          {formatCurrency(extra.prices[this.props.userCurrency.code].amount,
                            this.props.userCurrency)}</li>
                        <li className='text-right'>
                          <TrashIcon onClick={() => this.removeCartExtra(cartItem.unique_id, extra.extra_uuid)}/></li>
                      </ul>
              ))}
              <hr/>
            </div>);
  }

  formatDate(timeObj) {
    const firstDate = timeObj[0];
    const secondDate = timeObj[1] ? timeObj[1] : null;
    return secondDate ? `${formatMonthDayDate(firstDate)} - ${formatMonthDayDate(secondDate)}`
      : formatMonthDayDate(firstDate);
  }

  unityLabel(extra) {
    const labelTranslated = getLangValue(extra, this.props.lang, extra.quantity > 1
      ? 'unit_label_plural' : 'unit_label_singular');
    const defaultLabel = this.guests > 1 ? this.context.t('seats') : this.context.t('seat');
    return labelTranslated || defaultLabel;
  }

  renderPaxChildren(totals) {
    if (totals.allChildren === 0) {
      return null;
    }

    return (
            <DsLabel className='sandicon'>
              <b>{totals.allChildren}</b>
              &nbsp;{this.context.t(['child', 'children', 'n'], { n: totals.allChildren })}
              &nbsp;({totals.ages.join(', ')} {this.context.t('years')})
            </DsLabel>
    );
  }

  renderPaxTotals(totals) {
    if (this.isEmptyCart()) {
      return null;
    }

    return (
            <div>
              <DsLabel icon='user-icon' className='sandicon'>
                <b>{totals.adults}</b>
                &nbsp;{this.context.t(['adult', 'adults', 'n'], { n: totals.adults })}
              </DsLabel>
              {this.renderPaxChildren(totals)}
            </div>
    );
  }

  renderCartSummary(totals, addedRooms) {
    return (
            <div className="top-container-wrap">
              <div className="sandbox__top-info flex flex-col">
                <div>
                  <DsLabel icon='map-pointer'>
                    {this.props.hotel.name}
                  </DsLabel>
                </div>
                {this.renderPaxTotals(totals)}
              </div>
              <button className="FreeModeCart__header" onClick={this.toggleShowMobileCart}>
                <div className="cart-btn">
                  <CartIcon/>
                  <div className="cart-btn__number">{addedRooms}</div>
                </div>
              </button>
            </div>
    );
  }

  renderCartUpdating() {
    if (!this.props.cart.isUpdating) {
      return false;
    }

    return (
            <div>
              {this.context.t('Cart is updating...')}
            </div>
    );
  }

  renderCoinsDiscount() {
    if (this.isEmptyCart()) {
      return null;
    }
    /*
    // REVERT SI SE NECESITA CALCULAR MEMBER RATE Y SA NET RATE TOMANDO EN CUENTA EL COSTO DE LA RESERVA
    // SIN IMPUESTOS. AHROTIA LO TUVIMOS QUE DEJAR COMO ANTES, CALCULANDO EL MEMBER RATE Y SA NET RATE TOMANDO
    // EL COSTO TOTAL DE LA RESERVA CON IMPUESTOS
    ABAJO dice: -{formatCurrency(FinalRoomsAmount(this.props, null, false).totalAmount
    SI QUEREMOS QUE FUNCIONE TOMANDO EN CUENTA EL COSTO DE LA RESERVA SIN IMPUESTOS USAR:
    -{formatCurrency(FinalRoomsAmount(this.props, null, true).totalAmount
    */
    return (
          <Fragment>
            {(this.props.usedCoins != null && this.props.usedCoins !== 0)
            && <div className='discount'>
              -{formatCurrency(convertCoinsToCurrencyUsingRoundedConversionRate(this.props.coinsApplied), this.props.userCurrency)} {this.context.t('(Coins redeemed)')}
            </div>
            }
            {this.props.new_member === true
            && this.props.new_member_discount_percentage_activated === true
            && this.props.memberInfo.accountHolder != null
            && <div className='discount'>
              -{formatCurrency(FinalRoomsAmount(this.props, null, false).totalAmount * (this.props.new_member_discount_percentage / 100), this.props.userCurrency)} {this.context.t('{brand} {loyaltyLevel} Discount', { brand: this.props.loyaltyName, loyaltyLevel: this.props.memberInfo.membershipName.toUpperCase() })}
            </div>
            }
            {this.props.new_member === true
            && this.props.new_member_discount_percentage_activated === true
            && this.props.selectedStatus === 'becomeMember'
            && <div className='discount'>
              -{formatCurrency(FinalRoomsAmount(this.props, null, false).totalAmount * (this.props.new_member_discount_percentage / 100), this.props.userCurrency)} {this.context.t('New Member Discount')}
            </div>
            }
          </Fragment>
    );
  }

  render() {
    /*
    // REVERT SI SE NECESITA CALCULAR MEMBER RATE Y SA NET RATE TOMANDO EN CUENTA EL COSTO DE LA RESERVA
    // SIN IMPUESTOS. AHROTIA LO TUVIMOS QUE DEJAR COMO ANTES, CALCULANDO EL MEMBER RATE Y SA NET RATE TOMANDO
    // EL COSTO TOTAL DE LA RESERVA CON IMPUESTOS
    ABAJO dice: FinalRoomsAmount(this.props, null, false).totalAmount
    SI QUEREMOS QUE FUNCIONE TOMANDO EN CUENTA EL COSTO DE LA RESERVA SIN IMPUESTOS USAR:
    FinalRoomsAmount(this.props, null, true).totalAmount
    */
    const {
      rooms,
      isEmpty,
    } = this.props.cart.cartHotel;
    const cartClass = isEmpty ? 'opacity-7' : '';
    const cartTotals = this.getCartTotals(rooms);
    return (
            <div className={`FreeModeCart ${this.state.showMobileCart ? 'showon' : ''}`}>
              {this.renderCartSummary(cartTotals, rooms.length)}
              <FreeModeError code={this.props.cart.errorCode} source="cartUpdate">
                <div className="h6 font-weight-bold mr-3">
                  {this.context.t('There was an error updating your cart')}:
                </div>
              </FreeModeError>
              <div className="FreeModeCart__content">
                <div className={`sandbox border-primary mt-0 ${cartClass}`}>
                  {rooms.map((cartRoom, index) => this.renderRoom(cartRoom, index))}
                  {this.renderCoinsDiscount()}
                  {this.renderCartUpdating()}
                  {this.renderCartPrice(cartTotals.totalPrice
                  - convertCoinsToCurrencyUsingRoundedConversionRate(this.props.coinsApplied,
                    this.props.currency)
                  - (((this.props.isLoyaltyUserLoggedIn || this.props.selectedStatus === 'becomeMember')
                    && this.props.new_member_discount_percentage_activated && this.props.new_member)
                    ? FinalRoomsAmount(this.props, null, false).totalAmount
                    * (this.props.new_member_discount_percentage / 100)
                    : 0),
                  )}
                  {this.renderEmptyCartButton(rooms.length)}
                  {this.renderButton()}
                </div>
                <div className='pt-4'>
                  {this.renderGoToRoomsButton()}
                </div>
              </div>
            </div>
    );
  }
}

FreeModeCart.propTypes = {
  usedCoins: PropTypes.number,
  navigate: PropTypes.func.isRequired, // Prop para `navigate`
};

FreeModeCart.contextTypes = {
  t: PropTypes.func.isRequired,
  router:
  PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  lang: state.i18nState.lang,
  hotel: state.booking.hotel,
  loyaltyName: state.session.chainData.booking_engine_configuration.loyalty_name,
  lastInfo: state.booking.last_requested_info,
  userCurrency: state.booking.filterCurrency,
  showLoyalty: state.session.chainData.loyalty_coins_active,
  selectedStatus: state.loyalty.selectedStatus,
  currency: state.booking.filterCurrency,
  currencies: state.booking.currencies,
  device: state.booking.device,
  isCartUpdating: state.cart.isUpdating,
  multipleRoomSelection: state.booking.multipleRoomSelection,
  multipleRoomStep: state.booking.multipleRoomStep,
  lastRequestedInfo: state.booking.last_requested_info,
  chain: state.bookingFormState.chain,
  distributions: state.bookingFormState.distributions,
  utmParams: state.bookingFormState.utmParams || {},
  loggedUser: state.loyalty.loggedUser,
  memberInfo: state.loyalty.memberInfo,
  chainData: state.session.chainData,
  new_member: state.loyalty.newMember,
  new_member_discount_percentage: state.loyalty.newMemberDiscountPercentage,
  new_member_discount_percentage_chain: state.booking.hotel !== null
    ? state.session.chainData.loyalty_levels
      .find((member) => (member.membership_name === (state.bookingFormState.agentCode !== '' ? 'Blue Agent' : 'Blue')))
      .new_member_discount_percentage_hotels[state.booking.hotel.code.toLowerCase()]
    : 0,
  new_member_discount_percentage_activated: state.booking.hotel != null
    ? (state.booking.hotel.new_member_discount_percentage_activated === true
      && state.bookingFormState.agentSell === 'false') : false,
  coinsApplied: state.loyalty.coinsApplied,
  coinsEntered: state.loyalty.coinsEntered,
  isLoyaltyUserLoggedIn: state.loyalty.memberInfo ? !!state.loyalty.memberInfo.email : false,
  maxPercentUsage: state.loyalty.maxPercentUsage,
  conversionRates: state.loyalty.conversionRates,
  cart: state.cart,
  openReservationDetails: state.session.openReservationDetails,
  shouldShowNewShoppingCartMobileHeader: !!(window.location.pathname === '/rooms/'
      || window.location.pathname === '/confirmation/'),
  nights: state.booking.last_requested_info.nights,
  isCreatingBooking: state.session.isCreatingBooking,
  promoCode: state.bookingFormState.promoCode,
  isCallCenterUser: state.session.user.role === CALL_CENTER_ROLE,
  agentCode: state.bookingFormState.agentCode,
  agentSell: state.bookingFormState.agentSell,
});

const mapDispatchToProps = (dispatch) => ({
  emptyShoppingCart: (payload) => dispatch(emptyShoppingCart(payload)),
  setCoinsApplied: (payload) => dispatch(setCoinsApplied(payload)),
  setMaxCoinsToApply: (playload) => dispatch(setMaxCoinsToApply(playload)),
  setCoinsEntered: (playload) => dispatch(setCoinsEntered(playload)),
  removeFreeModeRoom: (payload) => dispatch(removeFreeModeRoom(payload)),
  removeFreeModeExtra: (payload) => dispatch(removeFreeModeExtra(payload)),
  setCartUpdating: (payload) => dispatch(setCartUpdating(payload)),
});

const ConnectedFreeModeCart = connect(mapStateToProps, mapDispatchToProps)(FreeModeCart);

// Exportar el componente envuelto con el HOC
export default withNavigate(ConnectedFreeModeCart);
